var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"percent_with_arrow mr-2"},[_c('v-icon',{staticClass:"mb-1 mx-1",attrs:{"size":"22","color":_vm.displayedColor}},[_vm._v(_vm._s(_vm.displayedIcon))]),_c('b',[_vm._v(_vm._s(_vm.displayedPercent)+"%")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }